export function getPlotOptionId(scatterPlotSecurity) {
    return `${scatterPlotSecurity.type}__${scatterPlotSecurity.id}`;
}
